<!--COMPONENTE PARA DEFINIR LA POSICIÓN DE LOS CAMPOS DE FIRMA EN EL DOCUMENTO
LA URL DEBE INCLUIR EL ID DE LA REQUEST Y EL TOKEN DE ACCESO
FORMATO: /fields/id?token=<token>&auth_id=<id>
-->

<template>
	<div id="pdf-box">
		<DefaultLoading v-if="loading || loadingBar" :loading="loading || loadingBar" />

		<v-container v-if="docError">
			<v-row class="fill-height" align-content="center" justify="center">
				<v-col cols="12">
					<v-alert border="top" colored-border type="error" elevation="2">
						{{ $t("document_error") }}
					</v-alert>
				</v-col>
			</v-row>
		</v-container>

		<v-container v-if="status === 'SIGNED'">
			<v-alert class="mt-5" border="left" text type="warning">
				{{ $t("document_already_signed") }}
			</v-alert>
		</v-container>
		<!-- BANNER INFORMATIVO -->
          <div
            class="info-banner"
            style="
              background: #e3f2fd;
              border: 1px solid #1976d2;
              color: #1976d2;
              padding: 12px;
              border-radius: 4px;
              margin-bottom: 16px;
              font-size: 0.95rem;
            "
          >
            {{ $t("fields.instruction") }}
          </div>

		<v-container v-if="!docError && status !== 'SIGNED' && !loading">

			<div id="pdf-view" class="col-md-12 pa-0" style="position:relative; height:80vh;">
              <vue-draggable-resizable
                ref="draggable"
                :x="rect.x" :y="rect.y" :w="rect.width" :h="rect.height"
                :parent="true"
                :prevent-deactivation="true"
                @dragstop="onDragStop"
                @resizestop="onResizeStop"
                style="position:absolute; z-index:1000;"
              >
                <!-- Tu rectángulo dibujado -->
                <div
                  style="
                    width:100%; height:100%;
                    border:2px dashed #1976d2;
                    background-color:rgba(25,118,210,0.5);
                    position:relative;
                  "
                ></div>

                <!-- Botón Save superpuesto en esquina -->
                <!-- Botón reducido y separado -->
                  <v-btn
                    ref="pinButton"
                    class="pin-btn"
                    small
                    color="#1976d2"
                    dark
                    elevation="1"
                    :loading="loading"
                    @click="save()"
                  >
                    <v-icon left>mdi-pin</v-icon>
                    {{ $t("fields.fix") }}
                  </v-btn>
              </vue-draggable-resizable>



              <PDFNavViewer
                ref="pdfViewer"
                v-if="pdfUrl && pdfUrl.startsWith('blob:')"
                :pdf-url="pdfUrl"
                public-path="/pdfjs"
                @documentError="documentError"
                @loaded="onDocumentLoad"
                style="height:100%; width:100%;"
              />
            </div>

		</v-container>

		<!-- <div class="footer-message" v-if="!docError && status !== 'SIGNED' && !loading">
			<div>
				<v-row>
					<v-container class="py-0 fill-height">

						<div class="col-md-2 col-6 reject" v-if="!isNoReject">
							<v-btn x-large block color="#F36E21" dark elevation="1" :loading="loading"
                                          @click="save()">
                                          {{ $t("fields.save") }}
                            </v-btn>
						</div>
					</v-container>
				</v-row>
			</div>
		</div> -->

	</div>
</template>

<script>

import PDFNavViewer from "../components/shared/PDFNavViewer.component.vue";


import DefaultLoading from "../components/shared/DefaultLoading.component";
import { SignaturesService } from "../services/signatures-service";


//añadir componente de redimensionamiento del campo
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';

export default {
/*
    props: {
      page:  { type: Number, default: 1 },
      scale: { type: Number, default: 1.0 },
    },
*/
	components: {
		PDFNavViewer,
		DefaultLoading,
		VueDraggableResizable, //nuevo componente
	},

	data: function () {
		return {
            pdfUrl: null,
			terms_accepted: null,
			confirm: false,
			loading: true,
			loadingBar: false,
			docError: false,
			error: false,
			requestId: "",
			token: "",
			authCitizenId: "",
			isAuthCitizen: null,
			showPdf: false,
			otpStatus: false,
			otpDialog: false,
			otpSend: false,
			otpCode: "",
			padDialog: false,
			padStatus: false,
			padImage: "",
			userLatitude: "",
			userLongitude: "",
			errorMsg: "",
			submitLocation: false,
			certificatePinCodeDialog: false,
			requestType: "",
			//Variables Fields
			// firma: posición/tamaño en px
            rect:    { x: 50, y: 50, width: 150, height: 50 },
            capturedPointer: null,
            // dimensiones de página en px y en mm
            pagePx: { width: 0, height: 0 },
            pageMm: { width: 0, height: 0 },

            // Página actual (prop o data)
            page:    1,
            scale:   1.0,

            // Guarda el viewport de PDF.js
            viewport: null,
            // eventos de Mouse
            isDragging: false,
            isResizing: false,

		};
	},


	computed: {

		auth() {
			return this.$store.state.common.auth;
		},
		status() {
			return this.$store.state.common.status;
		},

		authId() {
			return this.$store.state.common.authId;
		},
		hasAssociation() {
			return this.$store.getters['common/hasAssociation']
		},
		isNoReject() {
        return localStorage.getItem('noreject') === 'true'}
	},

	mounted() {
        console.log(Object.keys(localStorage));
        localStorage.removeItem("list");
        localStorage.removeItem("user");
        localStorage.removeItem("auth_user_token");
        localStorage.removeItem("request_id");
        localStorage.removeItem("access_token");
        // Listeners globales para capturar fuera del área del componente
        window.addEventListener('mousemove', this.onGlobalMouseMove);
        window.addEventListener('mouseup',   this.onGlobalMouseUp);

        // Inicializamos parámetros
        this.requestId = this.$route.params.id;
        localStorage.setItem("request_id", this.requestId);
        console.log("Request ID en Mounted: " + this.requestId);
        this.token = this.$route.query.token;
        localStorage.setItem("access_token", this.token);
        console.log("Access Token: " + this.token);
        this.authCitizenId = this.$route.query.auth_id || null;
        console.log("Cargando Auth ID: " + this.authCitizenId);
        localStorage.setItem('auth_id', this.authCitizenId);


//        this.$store.dispatch("common/addAuthId", "");

        console.log('[PdfView] mounted');
		// this.loadRequestData();
		this.loadDocument();
	},

	beforeDestroy() {
        // por si queda algo enganchado
        document.removeEventListener('mousemove', this.onGlobalMouseMove)
        document.removeEventListener('mouseup',   this.onGlobalMouseUp)
      },

	methods: {

         // 1) Cuando empieza drag o resize, capturamos el puntero en el DOM real
           onPointerDown(evt) {
                 // capturamos el pointer para que no se "escape"
                 const el = this.$refs.draggable.$el
                 if (evt.pointerId != null && el.setPointerCapture) {
                   el.setPointerCapture(evt.pointerId)
                   this.capturedPointer = evt.pointerId
                 }
                 el.addEventListener('pointerup', this.onPointerUp)
               },

           // 2) Cuando levantes el clic, soltamos el pointer capture
             onPointerUp() {
                   const el = this.$refs.draggable.$el
                   if (this.capturedPointer != null && el.releasePointerCapture) {
                     el.releasePointerCapture(this.capturedPointer)
                     this.capturedPointer = null
                   }
                   el.removeEventListener('pointerup', this.onPointerUp)
                 },

         // Se llama desde el mousedown sobre el rectángulo o el handle de resize
        onHandleMouseDown(evt, mode) {
              evt.stopPropagation();
              evt.preventDefault();
              this.isDragging = mode === 'drag';
              this.isResizing = mode === 'resize';
              this.dragStart = { x: evt.clientX, y: evt.clientY };
              this.rectStart = { ...this.rect };
            },

        // Con cada movimiento global actualizamos posición o tamaño
        onGlobalMouseMove(evt) {
          if (!this.isDragging && !this.isResizing) return;
          const dx = evt.clientX - this.dragStart.x;
          const dy = evt.clientY - this.dragStart.y;

          if (this.isDragging) {
            // Arrastrar
            this.rect.x = this.rectStart.x + dx;
            this.rect.y = this.rectStart.y + dy;
          } else if (this.isResizing) {
            // Redimensionar desde la esquina inferior derecha
            this.rect.width  = Math.max(20, this.rectStart.width  + dx);
            this.rect.height = Math.max(20, this.rectStart.height + dy);
          }
        },

        async waitForPdfDocument(retries = 10, delay = 300) {
          const pdf = this.$refs.pdfViewer?.$el?.contentWindow?.PDFViewerApplication;
          if (!pdf) {
            console.warn('⚠️ PDFViewerApplication no disponible aún.');
            return null;
          }

          for (let i = 0; i < retries; i++) {
            if (pdf.pdfDocument) {
              return pdf.pdfDocument;
            }
            console.log(`⏳ Esperando pdfDocument... intento ${i + 1}`);
            await new Promise(resolve => setTimeout(resolve, delay));
          }

          console.error('❌ No se pudo obtener pdfDocument tras múltiples intentos');
          return null;
        },

        documentError(err) {
            console.error("📄 Error al cargar el documento:", err);
              if (err !== undefined) {
                this.docError = true;
              } else {
                console.warn("⚠️ Evento documentError emitido sin argumento");
              }
          },

        onDocumentLoad(pdfInstance) {
            pdfInstance.getPage(this.page).then(pageObj => {
              // creamos el viewport a la escala actual
              const vp = pageObj.getViewport({ scale: this.scale });
              this.pagePx = { width: vp.width, height: vp.height };
              this.pageMm = {
                width:  (vp.width  * 25.4) / 72,
                height: (vp.height * 25.4) / 72,
              };
              // **guardamos el viewport** para convertir puntos después
              this.viewport = vp;
            });
          },

          /**
           * Se lanza tras soltar el rectángulo arrastrado.
           * @param {Number} left – nueva coordenada X en px
           * @param {Number} top  – nueva coordenada Y en px
           */

          onDragStop(left, top) {
                this.isDragging = false
                this.rect.x = left
                this.rect.y = top
                this.removeGlobalMouseUp()
              },

          /**
           * Se lanza tras soltar el rectángulo redimensionado.
           * @param {Number} left   – nueva X en px
           * @param {Number} top    – nueva Y en px
           * @param {Number} width  – nuevo ancho en px
           * @param {Number} height – nueva altura en px
           */

          onResizeStop(left, top, width, height) {
                this.isResizing = false
                this.rect = { x: left, y: top, width, height }
                this.removeGlobalMouseUp()
              },

          // Se ejecuta justo al empezar a arrastrar
              onDragStart() {
                this.isDragging = true
                this.addGlobalMouseUp()
              },
              // Se ejecuta justo al empezar a redimensionar
              onResizeStart() {
                this.isResizing = true
                this.addGlobalMouseUp()
              },

              // Añadimos un listener global para soltar el ratón en cualquier parte
              addGlobalMouseUp() {
                window.addEventListener('mouseup', this.onGlobalMouseUp)
              },
              removeGlobalMouseUp() {
                window.removeEventListener('mouseup', this.onGlobalMouseUp)
              },
              onGlobalMouseUp() {
                // Si estaba arrastrando, forzamos el stop
                if (this.isDragging) {
                  // obligamos a vue-draggable-resizable a emitir dragstop
                  this.$refs.draggable.$emit('dragstop', this.rect.x, this.rect.y)
                }
                if (this.isResizing) {
                  // forzamos resizestop
                  const { x, y, width, height } = this.rect
                  this.$refs.draggable.$emit('resizestop', x, y, width, height)
                }
                // limpiamos el flag y el listener
                this.isDragging = this.isResizing = false
                this.removeGlobalMouseUp()
              },

          /**
           * Al pulsar Guardar mostramos los valores actualizados:
           */

          async save() {
            try {
              // 1) Recuperar el iframe y la app de PDF.js
              const win = this.$refs.pdfViewer.iframeWindow
                       || this.$refs.pdfViewer.$el.querySelector('iframe').contentWindow;
              if (!win || !win.PDFViewerApplication) {
                throw new Error('PDFViewerApplication no disponible en el iframe');
              }
              const viewerApp = win.PDFViewerApplication;

              // 2) Página actual (aunque no cambie la escala, la seguimos leyendo)
              const pageNumber = viewerApp.pdfViewer.currentPageNumber;
              console.log(`👉 Página actual: ${pageNumber}`);

              // 3) Obtener pdfDocument y el objeto de la página
              const pdf    = viewerApp.pdfDocument;
              const page   = await pdf.getPage(pageNumber);

              // 4) Viewport sin escalar (scale: 1) para tener el alto en pt
              const vp     = page.getViewport({ scale: 1 });

              // 5) Rectángulo ya viene en px → pt (1px = 1pt cuando scale=1)
              const xPt    = this.rect.x;
              const yPt    = this.rect.y;
              const wPt    = this.rect.width;
              const hPt    = this.rect.height;
              console.log('Rect en pt:', { xPt, yPt, wPt, hPt });

              // 6) Ajuste de Y: PDF tiene origen abajo, JS origen arriba
              const yPdfPt = vp.height - yPt - hPt;

              // 7) Convertir de pt a mm (1 pt = 25.4/72 mm)
              const ptToMm = 25.4 / 72;
              const mmX      = xPt    * ptToMm;
              const mmY      = yPdfPt * ptToMm;
              const mmWidth  = wPt    * ptToMm;
              const mmHeight = hPt    * ptToMm;

              console.log(`📏 Coordenadas en mm sobre el PDF:`);
              console.log(`Pos X: ${mmX.toFixed(2)} mm`);
              console.log(`Pos Y: ${mmY.toFixed(2)} mm`);
              console.log(`Ancho: ${mmWidth.toFixed(2)} mm`);
              console.log(`Alto: ${mmHeight.toFixed(2)} mm`);

              // … aquí seguirías con la lógica de enviar/guardar esos valores

            } catch (err) {
              console.error('❌ Error en save():', err);
            }
          },



        async waitForDialogClose(dialogName) {
            return new Promise((resolve) => {
                // 🔍 Espera a que Vue actualice el DOM antes de observar cambios
                this.$nextTick(() => {
                    const watcher = this.$watch(dialogName, (newValue) => {
                        console.log(`Esperando cierre de ${dialogName}:`, newValue);
                        if (!newValue) {  // 🔴 Cuando el diálogo se cierra
                            console.log(`${dialogName} ha sido cerrado`);
                            watcher();  // 🛑 Detener el watcher
                            resolve();  // 🔄 Continuar con el siguiente paso
                        }
                    }, { immediate: true }); // 👈🏽 Comienza la observación de inmediato
                });
            });
        },

		changeConfirm() {
			this.confirm = !this.confirm;
		},

		loadRequestData() {
			this.loading = true;
			// this.requestId = this.$route.params.id;  //asignar requestid
            // this.token = this.$route.query.token;    //asignar token
            // this.authCitizenId = this.$route.query.auth_id || null;
            console.log("Leyendo auth_id en loadRequestData con valor: " + this.authCitizenId);
            localStorage.setItem('auth_id', this.authCitizenId);
            localStorage.setItem("access_token", this.token);
		},

         async loadDocument() {
           this.loading = true;
           console.log("authid: ", this.authCitizenId);
           console.log("Request ID en LoadDocument: " + this.requestId);
           this.docError = false;
           try {
             const resp = await SignaturesService.getSignatureRequestDocument(this.requestId);
             console.log("Documento obtenido");
             const blob = new Blob([resp.data], { type: "application/pdf" });
             this.pdfUrl = URL.createObjectURL(blob);
             console.log("PDF URL: " + this.pdfUrl);
             this.$emit("documentError", false);
           } catch (err) {
             console.error("🚨 loadDocument() - error capturado:", err);
             if (err.response?.status === 404) {
               console.log("Error 404");
               this.docError = true;
               this.$emit("documentError", true);
             }
           } finally {
             this.loading = false;
           }
         },

	},
};
</script>
